import React from "react";
import InputFactory from "../../../../../components/InputFactory";
import { saveFileUseCase } from "../../../../../usecases/file";

// Constants
const CURRENCY_FORMAT_OPTIONS = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

// Helper functions
const formatCurrency = (amount) =>
  `₱${Number(amount || 0).toLocaleString(undefined, CURRENCY_FORMAT_OPTIONS)}`;

const PaymentSummary = ({
  paymentDate,
  filteredData,
  paymentUpload,
  handlePaymentDateChange,
  handleFileChange,
  setViewBucket,
  viewBucket,
  handleDeleteRequest,
  setZoomSrc,
}) => (
  <div className="mt-5">
    <div className="col-sm-2 mb-3">
      <input
        className="form-control"
        type="date"
        value={paymentDate}
        disabled={filteredData.length === 0}
        onChange={handlePaymentDateChange}
      />
    </div>
    <h4>
      💳<span style={{ color: "#83c14a" }}> Payment</span> Type Summary
    </h4>
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            {["Payment Type", "Count", "Total Sales", "Action"].map(
              (header, index) => (
                <th
                  key={header}
                  className={
                    index === 1 ? "text-center" : index === 2 ? "text-end" : ""
                  }
                  style={{
                    backgroundColor: "#83c14a",
                    color: "white",
                    marginBottom: 12,
                  }}
                >
                  {header}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody>
          {paymentUpload.map((row) => (
            <tr key={row.name}>
              <td>{row.name}</td>
              <td className="text-center">{row.y}</td>
              <td className="text-end">{formatCurrency(row.totalAmount)}</td>
              <td>
                <InputFactory
                  type="MultipleFile"
                  field="shareArray"
                  saveFile={saveFileUseCase()}
                  multi
                  multiple
                  onChange={(value) => handleFileChange(value, row)}
                />
                <button
                  className="btn btn-link btn-sm me-2 mt-4"
                  onClick={() => setViewBucket(row)}
                  style={{
                    backgroundColor: "#83c14a",
                    color: "white",
                    marginBottom: 12,
                  }}
                >
                  View
                </button>

                {viewBucket?.name === row.name && (
                  <div className="bg-white p-4 rounded">
                    <div className="d-flex flex-wrap gap-2">
                      {Array.from(
                        new Set(
                          viewBucket.transactions.flatMap(
                            (tx) => tx.shareArray || []
                          )
                        )
                      ).map((url, i) => (
                        <div key={i} style={{ position: "relative" }}>
                          <img
                            src={url}
                            className="img-thumbnail"
                            alt={`Thumbnail ${i + 1}`}
                            style={{
                              width: 100,
                              height: 100,
                              objectFit: "cover",
                              cursor: "pointer",
                            }}
                            onClick={() => setZoomSrc(url)}
                          />
                          <button
                            onClick={() => handleDeleteRequest(url, viewBucket)}
                            style={{
                              position: "absolute",
                              top: 2,
                              right: 2,
                              background: "rgba(255,255,255,0.8)",
                              border: "none",
                              borderRadius: "50%",
                              width: 20,
                              height: 20,
                              padding: 0,
                              cursor: "pointer",
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                    <button
                      className="btn btn-secondary mt-3"
                      onClick={() => setViewBucket(null)}
                    >
                      Close
                    </button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default PaymentSummary;
